import { useTranslation } from 'react-i18next'

export interface DropdownOptionsAttractiveness {
  marketTypeOptions: Array<{ value: string; label: string }>
}

export const useGetAttractivenessDropdownOptions = (): DropdownOptionsAttractiveness => {
  const { t } = useTranslation()

  const marketTypeOptions = [{
    value: 'micro',
    label:t('placeme.attractiveness.market_type.micro'),
  }, {
    value: 'macro',
    label:t('placeme.attractiveness.market_type.macro'),
  }]

  return {
    marketTypeOptions,
  }
}
